// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ctm-payment-summary-settings[data-v-90956e22]{padding:4px 0}.ctm-ps-row[data-v-90956e22]{display:flex;align-items:center;flex-wrap:wrap;gap:8px;margin-bottom:14px}.ctm-ps-label[data-v-90956e22]{width:130px;font-size:13px;font-weight:500;color:#374151;flex-shrink:0}.ctm-ps-hint[data-v-90956e22]{font-size:11px;color:#9ca3af}", ""]);
// Exports
module.exports = exports;
